import { useQuery } from '@tanstack/react-query';
import { useCustomerDrawerStore } from '../../stores/customerDrawerStore';
import { api } from '../../lib/api';
import { CustomerInfoModal } from './CustomerInfoModal';

export function GlobalCustomerDrawer() {
  const { opened, customerId, customerName, provider, closeDrawer } = useCustomerDrawerStore();

  const isWeclapp = provider === 'weclapp';
  const isUuid = customerId ? /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(customerId) : false;
  const cwCompanyId = !isWeclapp && customerId && !isUuid ? Number(customerId) : undefined;
  const weclappCustomerId = isWeclapp && !isUuid ? customerId ?? undefined : undefined;
  const localCustomerId = isUuid ? (customerId ?? undefined) : undefined;

  // Nur abfragen, wenn der Drawer tatsächlich geöffnet ist. Diese Komponente
  // wird global (auch im Kundenportal) gemountet; ein ungeschützter Aufruf des
  // Techniker-Endpoints /technician-hub/provider würde dort einen 401 erzeugen
  // und den Kunden fälschlich auf das Techniker-Login werfen.
  const { data: providerData } = useQuery({
    queryKey: ['hub-provider'],
    queryFn: () => api.getHubProvider(),
    enabled: opened,
    staleTime: 5 * 60 * 1000,
  });

  const { data: contextData } = useQuery({
    queryKey: ['hub-customer-context', customerId, provider],
    queryFn: () =>
      api.getTechnicianHubCustomerContext(cwCompanyId, undefined, weclappCustomerId, localCustomerId),
    enabled: opened && customerId != null,
    staleTime: 2 * 60 * 1000,
  });

  if (!customerId) return null;

  return (
    <CustomerInfoModal
      opened={opened}
      onClose={closeDrawer}
      customerId={customerId}
      customerName={customerName}
      provider={provider}
      context={contextData?.context ?? null}
      externalUiBase={providerData?.externalUiBase ?? null}
    />
  );
}
